import Vue from "vue";
import Vuex from "vuex";

import Campaigns from "./modules/campaigns";
import Challenges from "./modules/challenges";
import ChallengeResults from "./modules/challenge_results";
import Submissions from "./modules/submissions";
import Users from "./modules/users";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Campaigns,
    Challenges,
    ChallengeResults,
    Submissions,
    Users,
  },
});
